import { ListTransactionsData, AccountsPaymentMethod } from '@dock/types-dock-partner';

export const filterTransactionsByMethod = (
    transactions: ListTransactionsData,
    filterBy: AccountsPaymentMethod
): ListTransactionsData => transactions.filter((el) => el.source.method === filterBy);
